import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, FormHelperText
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { createMatInwardEntry } from '../../Store/PHPSlice/MatInward';
import { errorStyles } from '../../Utils/table';


const MatInwardEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        materialNm: ' ',
        userId: userdata?.userId
    });
    const [errors, setErrors] = useState({});
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const materials = useSelector((state) => state.MaterialData.material || { data: [] });

    useEffect(() => {
        dispatch(fetchMaterialData())
    }, [dispatch]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleAddMaterial = () => {
        const selectedMaterial = materials.data.find(item => item.ID === formData.materialNm);
        if (selectedMaterial) {
            setTableRows([
                ...tableRows,
                {
                    id: tableRows.length + 1,
                    materialId: selectedMaterial.ID,
                    materialNm: selectedMaterial.materialNm,
                    description: selectedMaterial.description || '',
                    size: selectedMaterial.size || '',
                    packets: selectedMaterial.packets || '',
                    stkqty: ''
                }
            ]);
        }

        setFormData({
            ...formData,
            materialNm: ''
        })
    };

    const handleInputChange = (index, field, value) => {
        const updatedRows = tableRows.map((row, i) => {
            if (i === index) {
                return { ...row, [field]: value.toUpperCase() };
            }
            return row;
        });
        setTableRows(updatedRows);
    };
    const handleCheckboxChange = (rowId) => {
        if (selectedRows.includes(rowId)) {
            setSelectedRows(selectedRows.filter(id => id !== rowId));
        } else {
            setSelectedRows([...selectedRows, rowId]);
        }
    };

    const handleDeleteMaterial = () => {
        setTableRows(tableRows.filter(row => !selectedRows.includes(row.id)));
        setSelectedRows([]);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
   
        if (tableRows.length > 0) {
            var finalObject = {
                dt: formData.dt,
                matId: tableRows.map(row => row.materialId),
                pkt: tableRows.map(row => row.packets),
                qty: tableRows.map(row => row.stkqty),
                userId: formData.userId
            };

            dispatch(createMatInwardEntry(finalObject))
                .unwrap()
                .then((result) => {
                    // Handle success
                    console.log('POST request successful!', result);
                    toast.success("Material Inward Added");
                    window.location.reload();
                    // You may want to update your component state or perform any other action
                })
                .catch((error) => {
                    // Handle error
                    console.error('Error while making POST request:', error);
                    // You may want to display an error message to the user or perform any other action
                });
        } else {
            alert("Select Material Name & fill the Table");
           
        }



    };

    return (
        <>
            <Titlebar data={MaterialMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="materialNm">Material Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="materialNm"
                                                    id="materialNm"
                                                    name="materialNm"
                                                    value={formData.materialNm}
                                                    onChange={(e) => handleDropdownChange(e, 'materialNm')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        materials.data.length > 0 ? materials.data.map((item, index) => (
                                                            <MenuItem value={item.ID}>{item.materialNm} - {item.size}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                                {errors.materialNm && <FormHelperText style={errorStyles}>{errors.materialNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddMaterial} sx={{ mr: 2 }}>Add Material</Button>
                                    <Button variant="contained" color="primary" onClick={handleDeleteMaterial}>Delete Material</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ marginTop: '1%' }}>
                                        <TableContainer width={400} sx={{ border: '1px solid #ccc' }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Material Name</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Description</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Size</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Packets</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Stock Qty</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows.map((row, index) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(row.id)}
                                                                    onChange={() => handleCheckboxChange(row.id)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>{row.id}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                <TextField
                                                                    value={row.materialNm}
                                                                    onChange={(e) => handleInputChange(index, 'materialNm', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}

                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                <TextField
                                                                    value={row.description}
                                                                    onChange={(e) => handleInputChange(index, 'description', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                <TextField
                                                                    value={row.size}
                                                                    onChange={(e) => handleInputChange(index, 'size', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                <TextField
                                                                    value={row.packets}
                                                                    onChange={(e) => handleInputChange(index, 'packets', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                <TextField
                                                                    value={row.stkqty}
                                                                    onChange={(e) => handleInputChange(index, 'stkqty', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MatInwardEntry;
